var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"font-weight-bold fs-24 text-center mb-3 c-orange"},[_vm._v("\n    Dados Básicos\n    "),_c('i',{staticClass:"fas fa-clipboard-list ml-2"})])])
}]

export { render, staticRenderFns }